export default __webpack_public_path__ + "static/media/to-you-heart.e34b2a32.svg";